import React, { useRef } from 'react';
import { ShoppingCart as ShoppingCartIcon } from 'react-feather';
import clsx from 'clsx';

import Cart from 'components/Cart';

import PropTypes from 'prop-types';
import { Button, Dropdown } from 'ui-kit';

import './CartButton.scss';

const CartButton = ({
  handleCartButtonClick,
  isCartOpen,
  totalAmount,
  storeId,
  onEdit,
  mutateStoreList,
  storeCurrency,
}) => {
  const containerRef = useRef(null);
  return (
    <div ref={containerRef} className="Store_cartButtonContainer">
      <div className={clsx('Store_cartButtonContainer-backdrop', { visible: isCartOpen })} />
      <Dropdown
        className="Store_cartButtonContainer-menu"
        placement="bottomRight"
        trigger={['click']}
        overlay={
          <Cart
            isOpen={true}
            storeId={storeId}
            onEdit={onEdit}
            mutateStoreList={mutateStoreList}
            storeCurrency={storeCurrency}
          />
        }
        onVisibleChange={handleCartButtonClick}
        visible={isCartOpen}
        getPopupContainer={() => containerRef.current}
      >
        <Button
          className={'Store_cartButton'}
          color="textDark"
          startIcon={<ShoppingCartIcon />}
          type="button"
        >
          Cart
          <span className={clsx('Store_cartButtonAmount', { 'turned-on': totalAmount > 0 })}>
            {totalAmount}
          </span>
        </Button>
      </Dropdown>
    </div>
  );
};

CartButton.propTypes = {
  handleCartButtonClick: PropTypes.func,
  isCartOpen: PropTypes.bool,
  storeId: PropTypes.number,
  totalAmount: PropTypes.number,
  onEdit: PropTypes.func,
  mutateStoreList: PropTypes.func.isRequired,
  storeCurrency: PropTypes.string,
  handleAddItem: PropTypes.func,
};

export default CartButton;
